// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkHistorySidebar_header__Z1JGy {
  padding-left: 10px;

  font-size: 1rem;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/WorkHistory/WorkHistorySidebar.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".header {\n  padding-left: 10px;\n\n  font-size: 1rem;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `WorkHistorySidebar_header__Z1JGy`
};
export default ___CSS_LOADER_EXPORT___;
